<template>
  <v-card class="d-flex flex-column chart-card fill-height" elevation="0">
    <div class="header-chart px-6 py-0">
      <div class="d-flex align-center">
        <div class="card-title flex-1 mr-2">
          <slot name="title"></slot>
        </div>
        <a
          @click="resetCurrentChart"
          :style="{
            color: active ? '#ffbf00' : '#808080',
            display: active ? 'block' : 'none',
            whiteSpace : 'nowrap'
          }"
          class="text-caption"
          style="text-decoration: none"
          >{{ $t('instructions.resetFilter') }}</a
        >
      </div>
      <!-- The BUY/SELL swatches describe charts whose colours ARE the two
           sides. The heatmap paints a volume ramp instead, so the card opts
           out rather than showing a legend for colours it does not use. -->
      <buy-sell v-if="!hideSideLegend" />

    </div>

    <div class="d-flex chart-area px-3  py-3
    ">
      <slot></slot>
    </div>
  </v-card>
</template>

<script>
import { useAnalyticsProStore } from "@/store/analyticsStore";
import { mapStores } from "pinia";
import BuySell from "./BuySell.vue";
export default {
  props: ["active", "id", "hideSideLegend"],
  emits: ["resetCurrentChart"],
  computed: {
    ...mapStores(useAnalyticsProStore),
  },
  components: {
    BuySell,
  },
  data() {
    return {};
  },
  methods: {

    resetCurrentChart(e) {
      this.$emit("resetCurrentChart", e);
    }
  },
};
</script>
<style scoped>
.header-chart {
  display: grid;
  grid-template-columns: 2fr 1fr;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}


.card-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--text);
}

</style>
